import { ButtonBase } from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import clsx from "clsx";
import React from "react";
import styles from "./styles.module.scss";

export interface BackToHomeButtonProps {
  isMobile: boolean;
  isScrolled?: boolean;
  onClick: () => void;
}

export const BackToHomeButton: React.FC<BackToHomeButtonProps> = ({
  isMobile,
  isScrolled,
  onClick,
}) => {
  return (
    <ButtonBase
      className={clsx(styles.root, {
        [styles.compact]: isMobile,
        [styles.scrolled]: isMobile && isScrolled,
      })}
      onClick={onClick}
      aria-label="Back to home"
    >
      <ChevronLeftIcon className={styles.icon} />
      {!isMobile && <span>Back to home</span>}
    </ButtonBase>
  );
};
